import * as Styled from './PunchupModal.styles';

import { FC, ReactNode, useEffect } from 'react';
import { createPortal } from 'react-dom';

import { useIframeDialogClamp } from 'features/common/hooks/useIframeDialogClamp';

interface ModalProps {
	children: ReactNode;
	title: string;
	wide?: boolean;
}

export const PunchupModal: FC<ModalProps> = ({ children, title, wide = false }) => {
	// Portal to document.body so the modal escapes the attendee table's sticky actions-cell stacking
	// context (`position: sticky; z-index: 2`) — otherwise the action buttons of the rows BELOW the
	// pressed one paint on top of the modal and its scrim. (Green portals every modal for this reason.)
	// Also clamp to the parent's visible band when embedded so the card fits the mobile fold (TIC-636).
	// Portalled to body it has no positioned ancestor, so the default `absolute` clamp anchors to the
	// document origin; standalone/desktop keep the CSS `vh` sizing (both styles are undefined).
	const { isInIframe, overlayStyle, containerStyle } = useIframeDialogClamp();

	useEffect(() => {
		if (!isInIframe) return;

		document.body.style.overflow = 'hidden';
		return () => {
			document.body.style.overflow = '';
		};
	}, [isInIframe]);

	return createPortal(
		<Styled.Overlay className={isInIframe ? 'iframe-modal' : ''} style={overlayStyle}>
			<Styled.ModalContainer wide={wide} style={containerStyle}>
				<Styled.CheckIcon>
					<Styled.StyledCheck />
				</Styled.CheckIcon>
				<Styled.Title>{title}</Styled.Title>
				{children}
			</Styled.ModalContainer>
		</Styled.Overlay>,
		document.body
	);
};
